function updateProgramCards() {
	const cards = document.querySelectorAll(
		'.program-card.program-card--default, .program-card.program-card--horizontal'
	);

	// Loop through each card and update its class and image wrapper
	cards.forEach((card) => {
		const imageWrapper = card.querySelector('.program-card__image-wrapper');

		if (window.innerWidth <= 575) {
			card.classList.remove('program-card--default');
			card.classList.add('program-card--horizontal');

			// Wrap imageWrapper in 'program-card__image-col' if not already
			if (!imageWrapper.closest('.program-card__image-col')) {
				const imageCol = document.createElement('div');
				imageCol.className = 'program-card__image-col';
				imageWrapper.parentNode.insertBefore(imageCol, imageWrapper);
				imageCol.appendChild(imageWrapper);
			}
		} else {
			card.classList.remove('program-card--horizontal');
			card.classList.add('program-card--default');

			// Remove the image wrapper if it exists
			const imageCol = imageWrapper.closest('.program-card__image-col');
			if (imageCol) {
				imageCol.parentNode.insertBefore(imageWrapper, imageCol);
				imageCol.parentNode.removeChild(imageCol);
			}
		}
	});
}

// GLOBAL APP CONTROLLER
const controller = {
	init() {},
	loaded() {
		updateProgramCards();
	},
	resized() {
		updateProgramCards();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};

export default controller;
